export default "__VITE_ASSET__iJHQ5bVu__"